import React, { Component } from "react";
import {
  Steps,
  Button,
  Timeline,
  message,
  Card,
  Modal,
  Table,
  Icon,
  Result
} from "antd";
import CSVReader from "react-csv-reader";
import Ajv from 'ajv'
import * as loginActions from "../actions";
import { connect } from "react-redux";

const { Step } = Steps;

var ajv = new Ajv({allErrors: true});
// var schemaValidator = Ajv();

const innerSchema = {
  "type" : "object",
  "properties" : {
      "EMAIL" :  { "type": "string", "format": "email" },
      "NAME" :  { "type": "string"},
      "BRANCH" : { "type" : "string"},
      "ROLLNUMBER":{ "type" : "string"},
      "CAMPUS":{ "type" : "string", "enum" : ["VIT" , "BVRIT","BVRITH","SVECW"]}
  },
  "required" : ["EMAIL","NAME","BRANCH","CAMPUS","ROLLNUMBER"]
  }
  
  const schema = {
  "type" : "array",
  "items" : innerSchema
  }
  
const testSchemaValidator = ajv.compile(schema);

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      fileTypeValid:false,
      studentsData:[],
      uploadButtonDisabled:false,
    };
  }

  next() {
    const current = this.state.current + 1;
    this.setState({ current });
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  onUploadButtonClick(data){
    this.setState({uploadButtonDisabled:true})
    this.props.uploadStudentsDataToDatabase(data)
    this.props.closeModel()
  }

  render() {
    const handleForce = (data, fileName) => {
      
      fileName.split(".");
      if (fileName.split(".").pop() != "csv" || data.length==0) {
        // alert("File type is Invalid. Please upload only CSV File. Check the description for format")
        Modal.error({
          title: "Invalid File TYPE. [Only CSV File format is supported]",
          content:
            "File type is Invalid. Please upload only CSV File. Check the description for format. And make sure CSV file has data in it"
        });
      } else {
        
        var valid = testSchemaValidator(data);
        
        if(!valid) {
          Modal.error({
            title: "Data in not Falid. Please check the Sample Data in Step 1 or contact admin@vedic.dev",
            content:
            ajv.errorsText(testSchemaValidator.errors)
          }); 
        }
        if(valid){
          message.success("Data validation successfull.Please Proceed to next step");
          this.setState({ current:2,studentsData:data });
        }
       
      }
    };
    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      preview:450,
      transformHeader: header => header.toUpperCase()
    };

    const stepOne = (
      <div>
        <Table
          pagination={false}
          footer={() => (
            <a href="https://vedic.dev/sample_data.csv"><Button
            icon="download"
            type="primary"
            ghost
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            Download Sample File (CSV)
          </Button></a>
          )}
          title={() => (
            <>
              <p style={{ marginTop: 10, marginBottom: 10 }}>
                Please make sure to follow the same data format as sample file.
                And supported file format is <b>CSV</b>{" "}
              </p>
              <p>
                Required Fields* <br />
              </p>
              <p>
                <b style={{ color: "black" }}>NAME</b> - Student Name
              </p>
              <p>
                <b style={{ color: "black" }}>EMAIL</b> - Student email (same
                email used for students login. - Only GMAIL-ID Allowed)
              </p>
              <p>
                <b style={{ color: "black" }}>BRANCH</b> - Students Branch
              </p>
              <p>
                <b style={{ color: "black" }}>ROLLNUMBER</b> - Students Registration Number
              </p>
              <p>
                <b style={{ color: "black" }}>CAMPUS</b> - Students Campus
                (Allowed Names - BVRIT, BVRITH, SVECW, VIT)
              </p>
              <p style={{marginTop:10}}>
                <b style={{ color: "black",paddingTop:20,fontSize:15 }}>Maximum of <u>450</u> students can be uploaded at once</b>
              </p>
            </>
          )}
          bordered
          columns={[
            {
              title: "NAME",
              dataIndex: "NAME",
              key: "NAME"
            },
            {
              title: "EMAIL",
              dataIndex: "EMAIL",
              key: "EMAIL"
            },
            {
              title: "BRANCH",
              dataIndex: "BRANCH",
              key: "BRANCH"
            },
            {
              title: "CAMPUS",
              dataIndex: "CAMPUS",
              key: "CAMPUS"
            },
            {
              title: "ROLLNUMBER",
              dataIndex: "ROLLNUMBER",
              key: "ROLLNUMBER"
            }
          ]}
          dataSource={[
            {
              NAME: "Prashanth",
              EMAIL: "admin@vedic.dev",
              BRANCH: "ECE",
              CAMPUS: "BVRIT",
              ROLLNUMBER:"17A05624LJ"
            }
          ]}
        />

        <Button
          style={{ marginTop: 30 }}
          type="primary"
          onClick={() => this.next()}
        >
          Next Step
        </Button>
      </div>
    );

    const stepTwo = (
      <div style={{textAlign:"center"}}>
         <p style={{ marginTop: 10, marginBottom: 10 }}>
                Please make sure to follow the same data format as sample file.
                And supported file format is <b>CSV</b>{" "}
              </p>
              <div style={{"borderColor":"red","borderStyle":"dashed","border":"6px","borderRadius":"6px","backgroundColor":"rgb(246, 238, 238)","padding":"23px"}}>
        <CSVReader
          inputStyle={{padding:10}}
          cssClass="react-csv-input"
          onFileLoaded={handleForce}
          parserOptions={papaparseOptions}
        />
        </div>
      <div>      
        <Button style={{ marginTop: 15 }} onClick={() => this.prev()}>
          Previous step
        </Button>
        </div>
        
      </div>
    );
    
    const stepThree = <>
     <Result
    title={"Found" + this.state.studentsData.length + " students from csv file. Would you like to proceed?"}
    extra={
      <Button loading={this.state.uploadButtonDisabled} disabled={this.state.uploadButtonDisabled} type="primary" onClick={() => this.onUploadButtonClick(this.state.studentsData)} key="console">
    {this.state.uploadButtonDisabled ? "Uploading" : "Click to add students to database" }
      </Button>
    }
  /></>
    const steps = [
      {
        title: "Download sample File",
        content: stepOne
      },
      {
        title: "Upload & Verify File",
        content: stepTwo
      },
      {
        title: "Insert to Database",
        content: stepThree
      }
    ];

    const { current } = this.state;

    return (
      <div>
        <Card bordered={false} hoverable>
          <Steps current={current} style={{ padding: 20 }}>
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content">{steps[current].content}</div>

          {/* <div className="steps-action">
              {current < steps.length - 1 && (
                <Button type="primary" onClick={() => this.next()}>
                  Next
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button type="primary" onClick={() => message.success('Processing complete!')}>
                  Done
                </Button>
              )}
              {current > 0 && (
                <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
                  Previous
                </Button>
              )}
            </div> */}
        </Card>
      </div>
    );
  }
}
const mapStateToProps = state => {
  

  return {
    skeltonLoading: state.loading
  };
};

const mapDispachToProps = (dispatch, props) => ({
  uploadStudentsDataToDatabase: data => {
    dispatch(loginActions.uploadStudentsDataToDatabase(data));
  },
  onUnload: () => dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(mapStateToProps, mapDispachToProps)(UploadFile);
